export {
	ViewAsScopeService,
	ViewAsScope,
	ViewAsRole
} from './view-as-scope.service';
export { patchAmplifyApiForViewAsScope } from './api-view-as-patch';
